import type { FC } from 'react';
import { memo } from 'react';

import { useAppSelector } from '../../redux/hooks';
import type { MessageId } from './thread-slice';
import { getStateMsg } from './thread-slice-utils';
import type { ThreadMessageChildrenRef, ThreadMessageNodeProps } from './ThreadMessageNode';
import { ThreadMessageNode } from './ThreadMessageNode';

interface Props extends Omit<ThreadMessageNodeProps, 'parentMessageId' | 'currentMessageId'> {
  messageId: MessageId;
  nestedAnswersRef: ThreadMessageChildrenRef;
}

export const ThreadMessageNodeRecursiveWrapper: FC<Props> = memo(
  function ThreadMessageNodeRecursiveWrapper(props) {
    const { messageId, nestedAnswersRef, ...others } = props;

    const selectedId = useAppSelector(s => getStateMsg(s, messageId)?.selectedChildId ?? null);

    if (!selectedId) return null;

    return (
      <ThreadMessageNode
        // Specifying the key is useful to re-instantiate the component when changing of tree branch, to reset the initial state.
        // Otherwise, the selectedId of this child node will be set to the one of the other branch.
        // The alternative would be to reset it without reinstantiating the component, which will require more development.
        key={messageId}
        ref={nestedAnswersRef}
        className="ThreadMessageNodeRecursiveWrapper"
        parentMessageId={messageId}
        currentMessageId={selectedId}
        {...others}
      />
    );
  },
);
